import {WebStorageStateStore} from "oidc-client-ts"


const clientId = process.env.REACT_APP_OIDC_CLIENT_ID
const userStateStore = new WebStorageStateStore({ store: window.localStorage })

const onSigninCallback = () => {
    window.history.replaceState(
        {},
        document.title,
        window.location.pathname
    )
}

const config = {
    userStore: userStateStore,
    client_id: clientId,
    onSigninCallback: onSigninCallback
}

export {
    config,
    userStateStore
}
